export default class RoutemParticleHandler {
  constructor() {
    this.device_platform =
      /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(
        window.navigator.userAgent
      )
        ? "tablet"
        : /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
            window.navigator.userAgent
          )
        ? "mobile"
        : "desktop";

    this.screen_name = window.location.pathname.toString();
  }

  // Generic function to send an event
  sendEvent(event_name, args) {
    mParticle.logEvent(event_name, mParticle.EventType.Other, args);
  }

  /*
   * GENERAL EVENTS
   */
  logScreenViewedEvent() {
    this.sendEvent("Screen-Viewed", {
      screen_name: this.screen_name,
      device_platform: this.device_platform,
    });
  }

  /*
   * LEAD FORM EVENTS
   */
  logGetDemoButtonTappedEvent(location_source_name, treatment) {
    this.sendEvent("Dotcom-GetDemo-Button-Tapped", {
      screen_name: this.screen_name,
      location_source_name: location_source_name,
      device_platform: this.device_platform,
      treatment: treatment,
    });
  }

  logLeadFormViewedEvent(demoleadform_version) {
    this.sendEvent("Dotcom-DemoLeadForm-Viewed", {
      screen_name: this.screen_name,
      demoleadform_version: demoleadform_version,
      device_platform: this.device_platform,
    });
  }

  logMerchantButtonTappedEvent(demoleadform_version, email_address) {
    this.sendEvent("Dotcom-DemoLeadForm-Merchant-Button-Tapped", {
      screen_name: this.screen_name,
      demoleadform_version: demoleadform_version,
      device_platform: this.device_platform,
      email_address: email_address,
    });
  }

  logRequestDemoTappedEvent(demoleadform_version, treatment) {
    this.sendEvent("Dotcom-DemoLeadForm-RequestDemo-Button-Tapped", {
      screen_name: this.screen_name,
      demoleadform_version: demoleadform_version,
      device_platform: this.device_platform,
      treatment: treatment,
    });
  }

  logDemoFormSubmittedEvent(submitStatus, treatment) {
    this.sendEvent("DemoFormSubmitted", {
      status: submitStatus,
      treatment: treatment,
    });
  }

  /*
   * SIGN IN NAV EVENTS
   */
  logSignInNavTappedEvent() {
    this.sendEvent("Dotcom-Signin-Nav-Tapped", {
      screen_name: this.screen_name,
      device_platform: this.device_platform,
    });
  }

  logShopperClaimButtonTappedEvent() {
    this.sendEvent("Dotcom-RouteShopper-ClaimButton-Tapped", {
      screen_name: this.screen_name,
      device_platform: this.device_platform,
    });
  }

  logShopperSignInButtonTappedEvent() {
    this.sendEvent("Dotcom-RouteShopper-SigninButton-Tapped", {
      screen_name: this.screen_name,
      device_platform: this.device_platform,
    });
  }

  logMerchantSignInButtonTappedEvent() {
    this.sendEvent("Dotcom-RouteMerchant-SigninButton-Tapped", {
      screen_name: this.screen_name,
      device_platform: this.device_platform,
    });
  }

  // get inner props

  getDevicePlatform() {
    return this.device_platform;
  }

  getScreenName() {
    return this.screen_name;
  }
}
